module.exports = __webpack_public_path__ + "img/63203d2.png";